export default "__VITE_ASSET__CrWnBEBr__"